import { Polyline, PolylineProps } from "react-leaflet";

export const DragStylePolyline = ({
  positions,
}: {
  positions: PolylineProps["positions"];
}) => (
  <>
    <Polyline
      positions={positions}
      pathOptions={{ color: "black", opacity: 0.15, weight: 9 }}
    />
    <Polyline
      positions={positions}
      pathOptions={{ color: "white", opacity: 0.8, weight: 6 }}
    />
    <Polyline
      positions={positions}
      pathOptions={{ color: "red", opacity: 1, weight: 2, dashArray: "7,12" }}
    />
  </>
);
